import { AppConsts } from '@shared/AppConsts';

/** Values that must not be bound to img[src] (placeholder sentinels / bad cache). */
const EMPTY_PROFILE_IMAGE_VALUES = new Set(['', 'undefined', 'null']);

/**
 * Picks the first usable profile image URL from the given candidates and normalizes it
 * for img[src] (handles blob CDN URLs, data URLs, assets paths, and bare base64).
 */
export function resolveProfileImageUrl(...candidates: (string | null | undefined)[]): string {
    for (const candidate of candidates) {
        const normalized = normalizeProfileImageUrl(candidate);
        if (normalized) {
            return normalized;
        }
    }

    return '';
}

export function normalizeProfileImageUrl(value: string | null | undefined): string {
    if (value == null) {
        return '';
    }

    const trimmed = value.trim();
    if (EMPTY_PROFILE_IMAGE_VALUES.has(trimmed) || trimmed === AppConsts.BackgroundImagephoto) {
        return '';
    }

    if (
        trimmed.startsWith('data:') ||
        trimmed.startsWith('http://') ||
        trimmed.startsWith('https://') ||
        trimmed.startsWith('assets/') ||
        trimmed.startsWith('/assets/')
    ) {
        return trimmed;
    }

    // Some APIs persist only the base64 payload without a data: prefix.
    if (/^[A-Za-z0-9+/=]+$/.test(trimmed) && trimmed.length > 100) {
        return `data:image/jpeg;base64,${trimmed}`;
    }

    return '';
}

export function isProfileImageDataUrl(value: string | null | undefined): boolean {
    return !!value && value.trim().startsWith('data:');
}
